const React = require("react");
const DashboardBlockTitle = require("../DashboardBlockTitle");
const DashboardBlock = require("../DashboardBlock");
const CopyField = require("./components/CopyField");

module.exports = ({acceptance, onRamp}) => (
  <DashboardBlock>
    <DashboardBlockTitle>
      Codes
    </DashboardBlockTitle>
    <div className="mt5">
      <CopyField
        label="referral code"
        value={acceptance}
      />
    </div>
    <div className="mt4">
      <CopyField
        label="On-Ramp code"
        value={onRamp}
      />
    </div>
  </DashboardBlock>
);
